jQuery(document).ready(function($) {

    const $body = $('body'),
        $html = $('html'),
        testimonialSelector = '.js-testimonial',
        $modal = $('#modal-testimonials'),
        modalSelector = '#modal-testimonials',
        readmoreSelector = ".read-more",
        closeSelector = ".js-modal-close"
        ;

    $body.on('click', '.js-modal-trigger', function(e) {
        const $trigger = $(this);
        const target = $trigger.data('modal');
        $(target).toggleClass('active');
    });

    $body.on('click', '.js-modal-trigger', function(e) {
        const $trigger = $(this);
        const target = $trigger.data('modal');
        if (target == '#modal-new-site') {
            console.log(e);
            // set cookie to indicate the new site modal has been seen
            document.cookie = "newSiteModalSeen=true; path=/";
        }
    });




    function modalOpen() {
       
        const $testimonial = $(this).closest(testimonialSelector);

        const content = {
            'title' : $testimonial.find('.js-title').html(),
            'body' : $testimonial.find('.js-modal-content').html(),
            'age' : $testimonial.find('.js-age').html(),
        };
 
        $modal
            .addClass('modal-active')
            .find('.js-modal-body')
            .html(content.body)
            .end()
            .find('.js-modal-title')
            .html(content.title)
            .end()
            .find('.js-modal-age')
            .html(content.age)
            ;
        
        $html
            .css('overflow', 'hidden')
            ;
    }

    function modalClose(e) {

        const $target = $(e.target);
        
        if ($target.hasClass('modal-container') || $target.hasClass('js-modal-body')) return;

        $modal
            .removeClass('modal-active')
            ;
        $html
            .css('overflow', 'visible')
            ;
    }

    $body
        .on('click', readmoreSelector, modalOpen)
        .on('click', closeSelector, modalClose)
        .on('click', modalSelector, modalClose)
        ;

});